import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { MathBlock } from "../components/MathRender";
import { StatusBadge } from "../components/StatusBadge";
import { Plus, Clock, Award } from "lucide-react";

export default function Solve() {
  const { user } = useAuth();
  const [problems, setProblems] = useState([]);

  useEffect(() => {
    api.get("/solve/problems").then((r) => setProblems(r.data)).catch(() => {});
  }, []);

  const fmtDeadline = (d) => (d ? new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");

  return (
    <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8" data-testid="solve-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow mb-2">Solve</p>
          <h1 className="font-display text-3xl tracking-tight text-slate-900 sm:text-4xl">Commission Marketplace</h1>
          <p className="mt-3 max-w-2xl text-slate-500">Paid, assigned mathematical work with fixed acceptance criteria, deadlines, and contracted awards.</p>
        </div>
        {user?.role === "customer" && (
          <Link to="/solve/new" data-testid="new-problem-btn" className="btn-crimson">
            <Plus className="h-4 w-4" /> Commission a problem
          </Link>
        )}
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {problems.map((p) => (
          <Link to={`/solve/${p.id}`} key={p.id} data-testid={`problem-card-${p.id}`} className="axiom-card group flex flex-col p-6">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2">
                <span className="rounded-full border border-[#CBD5E1] px-2.5 py-0.5 text-[11px] font-mono text-[#D4AF37]">{p.domain}</span>
                <span className="text-[11px] font-mono text-slate-500">{p.difficulty}</span>
              </div>
              <StatusBadge status={p.status} />
            </div>
            <h3 className="mt-3 font-display text-xl text-slate-900">{p.title}</h3>
            <div className="mt-3 opacity-90"><MathBlock>{p.statement_latex}</MathBlock></div>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-slate-500">
              <span className="inline-flex items-center gap-1.5 text-emerald-700"><Award className="h-4 w-4" /> ${p.prize_amount?.toLocaleString()} award</span>
              <span className="inline-flex items-center gap-1.5"><Clock className="h-4 w-4" /> Due {fmtDeadline(p.deadline)}</span>
              <span className="font-mono">{p.submission_count} submissions</span>
            </div>
          </Link>
        ))}
      </div>
      {problems.length === 0 && <p className="mt-10 text-slate-500">No active commissions yet.</p>}
    </div>
  );
}
